import React from "react";

import {
  InboundWebhookURLField,
  WebhookURLs,
} from "src/connections/config/inboundWebhook/InboundWebhookURLField";

export const InboundWebhookConnectionCreatedForm: React.FC<WebhookURLs> = ({
  productionWebhookURL,
  sandboxWebhookURL,
}) => {
  return (
    <InboundWebhookURLField
      productionWebhookURL={productionWebhookURL}
      sandboxWebhookURL={sandboxWebhookURL}
    />
  );
};
